<template>
    <div>
        <div class="form-container">
            <div class="title">付款申请</div>
            <div class="payment-content margin-b20">付款申请单号: {{baseData.paymentNo}}</div>
            <div class="payment-content">付款申请名称: {{baseData.payTitle}}</div>
        </div>
        <div class="form-container">
            <div class="title">支付明细</div>
            <div class="payment-content margin-b20">{{baseData.paymentName}}</div>
            <div class="payment-content">金额: {{baseData.payAmount}}</div>
        </div>
        <eui-btn type="primary" font-size="12px" style="float: right" v-debounce="evaluatePaymentSend">发 送</eui-btn>
    </div>
</template>
<script>
    import api from '@/modules/projectA/api/ESorganization/index';
    export default {
        name: "ESorganizationPayment",
        data(){
            return{
                baseData:{},
                reqParams:{},
            }
        },
        methods:{
            async getEvaluationPaymentOnlinePreview(){
                this.reqParams = this.$route.query;
                let res = await api.getEvaluationPaymentOnlinePreview(this.reqParams);
                if(res.success){
                    this.baseData = res.data;
                }
            },
            async evaluatePaymentSend(){
                let params = {
                    applyId:this.reqParams.applyId,
                    paymentNo:this.baseData.paymentNo,
                    paymentName:this.baseData.paymentName
                };
                let res = await api.evaluatePaymentSend(params);
                if(res.success){
                    this.$message.success('这是提示');
                    this.$router.push('/ES/ESapply');
                }
            },
        },
        mounted() {
            this.getEvaluationPaymentOnlinePreview();
        }

    }
</script>

<style scoped lang="scss">
    .title {
        color: #333;
        font-size: 16px;
        line-height: 16px;
        margin-bottom: 20px;
        font-weight: 500;
    }

    .payment-content {
        color: #333;
        font-size: 14px;
        line-height: 14px;
    }
</style>